<template>
    <div class="o-vacancies-filters">
        <div class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell" v-if="filter_title">
                    <h2 class="o-vacancies-filters__title" v-html="filter_title"></h2>
                </div>
                <div class="small-12 medium-9 cell">
                    <div class="o-vacancies-filters__wrapper">
                        <div class="grid-x grid-margin-x">
                            <location-filter :filters="filters" v-if="activeFilters['specific_region'].value == null && filter_visibility.show_regions"></location-filter>
                            <taxonomy-filter v-if="filter_visibility.show_job_roles" filter_name="job_roles" :filters="filters"></taxonomy-filter>
                            <taxonomy-filter v-if="filter_visibility.show_practice_type" filter_name="practice_types" :filters="filters"></taxonomy-filter>
                            <taxonomy-filter v-if="filter_visibility.show_contract_type" filter_name="contract_types" :filters="filters"></taxonomy-filter>
                            <taxonomy-filter v-if="filter_visibility.show_salary_ranges" filter_name="salary_ranges" :filters="filters"></taxonomy-filter>
                            <div class="cell small-12 medium-6 large-4">
                                <div class="o-vacancies-filters__practice-name-filter">
                                    <input type="text" name="practice_name" placeholder="Practice Name">
                                    <div class="o-vacancies-filters__practice-name-toggle">
                                        <i class="c-icon icon-search"></i>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="small-12 medium-3 cell">
                    <button class="o-vacancies-filters__reset-button" type="button" @click="resetFilters()">
                        {{ $t("vacancies.reset") }}
                    </button>
                    <button class="o-vacancies-filters__submit-button" type="button" @click="filterJobs()">
                        {{ $t("vacancies.search") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import LocationFilter from './location-filter';
    import TaxonomyFilter from './taxonomy-filter';

    import vacanciesMixin from "../../../mixins/vacancies";

    export default {
        name: 'VacanciesFilter',
        props: ['filter_title', 'filters', 'filter_visibility'],
        components: {
            LocationFilter,
            TaxonomyFilter
        },
        mixins: [vacanciesMixin],
    }
</script>